export var MarketEnum;
(function (MarketEnum) {
    MarketEnum[MarketEnum["GENERAL"] = 14] = "GENERAL";
    MarketEnum[MarketEnum["CISCO"] = 1] = "CISCO";
    MarketEnum[MarketEnum["MICROSOFT"] = 2] = "MICROSOFT";
    MarketEnum[MarketEnum["HPE"] = 3] = "HPE";
    MarketEnum[MarketEnum["LENOVO"] = 4] = "LENOVO";
    MarketEnum[MarketEnum["DELL"] = 5] = "DELL";
    MarketEnum[MarketEnum["IBM"] = 6] = "IBM";
    MarketEnum[MarketEnum["REDHAT"] = 7] = "REDHAT";
    MarketEnum[MarketEnum["VMWARE"] = 8] = "VMWARE";
})(MarketEnum || (MarketEnum = {}));
export const MARKET_NAMES = {
    [MarketEnum.GENERAL]: 'General Market',
    [MarketEnum.CISCO]: 'Cisco Market',
    [MarketEnum.MICROSOFT]: 'Microsoft Market',
    [MarketEnum.HPE]: 'HPE Market',
    [MarketEnum.LENOVO]: 'Lenovo Market',
    [MarketEnum.DELL]: 'Dell Market',
    [MarketEnum.IBM]: 'IBM Market',
    [MarketEnum.REDHAT]: 'Red Hat Market',
    [MarketEnum.VMWARE]: 'VMware Market',
};
//# sourceMappingURL=markets.js.map